import styled from '@emotion/styled';
import { FONT, MEDIA_QUERY, SPACING } from '@zola/zola-ui/src/styles/emotion';
import H from '@zola/zola-ui/src/typography/Headings';
import P from '@zola/zola-ui/src/typography/Paragraphs';

export const Container = styled.div`
  width: 100%;
  padding: ${SPACING.S32} ${SPACING.S24};
  ${MEDIA_QUERY.TABLET} {
    padding: 64px 56px;
  }
  ${MEDIA_QUERY.DESKTOP} {
    padding: ${SPACING.XL};
  }
`;

export const InnerContainer = styled.div`
  ${MEDIA_QUERY.EXCLUDE_MOBILE} {
    text-align: center;
    align-items: center;
  }
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
`;

export const H1 = styled(H.Title1)`
  margin-bottom: ${SPACING.S8};
  ${MEDIA_QUERY.TABLET} {
    margin-bottom: ${SPACING.S16};
    ${FONT.textSizeRegular(FONT.FONT_SIZE_LARGER)};
  }
  ${MEDIA_QUERY.DESKTOP} {
    text-align: center;
    margin-bottom: ${SPACING.S24};
    ${FONT.textSizeRegular(FONT.FONT_SIZE_SEMI_HUGE)};
  }
`;

export const Dek = styled(P.BodyBase)`
  max-width: 640px;
  margin-bottom: ${SPACING.S16};
  ${FONT.textSizeCompact(FONT.FONT_SIZE_SMALL)};
  ${MEDIA_QUERY.TABLET} {
    text-align: center;
    margin-bottom: ${SPACING.S24};
  }
  ${MEDIA_QUERY.DESKTOP} {
    text-align: center;
    margin-bottom: ${SPACING.S32};
    ${FONT.textSizeCompact(FONT.FONT_SIZE_REGULAR)};
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: flex-start;
  ${MEDIA_QUERY.EXCLUDE_MOBILE} {
    align-items: center;
  }
  justify-content: center;
  gap: ${SPACING.S8};
  ${MEDIA_QUERY.MOBILE} {
    flex-direction: column;
  }
`;
